import { StandaloneChargeStatusEnum } from '../../services/standalone-charges';

import {
  ActivationFormState,
  BillingEstatesFiltersState,
  BillingEstatesSortState,
  CommissioningFiltersState,
  CreateCommissioningCollaboratorFormState,
  CreateFormState,
  FiltersState
} from './types';

export const standaloneChargesLabel = 'Cobranças';

export const statusOptions = [
  { key: 'PENDING_PAYMENT', value: 'PENDING_PAYMENT', text: 'Pendente' },
  { key: 'PAID', value: 'PAID', text: 'Paga' },
  { key: 'REFUNDED', value: 'REFUNDED', text: 'Valor estornado' },
  { key: 'CANCELLED', value: 'CANCELLED', text: 'Cancelada' },
  { key: 'EXPIRED', value: 'EXPIRED', text: 'Expirado' }
];

export const statusLabelMap: Record<string, string> = {
  [StandaloneChargeStatusEnum.pendingPayment]: 'Pendente',
  [StandaloneChargeStatusEnum.paid]: 'Paga',
  [StandaloneChargeStatusEnum.refunded]: 'Valor estornado',
  [StandaloneChargeStatusEnum.cancelled]: 'Cancelada',
  [StandaloneChargeStatusEnum.expired]: 'Expirado'
};

export const initialFilters: FiltersState = {
  estateId: '',
  estateUnitId: '',
  type: 'payer',
  argument: '',
  status: '',
  startDate: '',
  endDate: ''
};

export const initialCommissioningFilters: CommissioningFiltersState = {
  estateId: '',
  type: 'name',
  argument: '',
  status: ''
};

export const initialBillingEstatesFilters: BillingEstatesFiltersState = {
  name: '',
  status: ''
};

export const initialBillingEstatesSort: BillingEstatesSortState = {
  sortBy: 'estateName',
  sortOrder: 'ASC'
};

export const billingEstateStatusLabelMap: Record<string, string> = {
  ACTIVE: 'Ativa',
  BIOMETRY_PENDING: 'Biometria pendente/em análise',
  BIOMETRY_REJECTED: 'Biometria recusada',
  SUPPORT_REQUIRED: 'Análise necessária',
  REGISTRATION_INCOMPLETE: 'Cadastro incompleto',
  REGISTRATION_PENDING: 'Cadastro pendente'
};

export const billingEstateStatusOptions = [
  { key: 'all', value: '', text: 'Todos' },
  { key: 'ACTIVE', value: 'ACTIVE', text: 'Ativa' },
  {
    key: 'BIOMETRY_PENDING',
    value: 'BIOMETRY_PENDING',
    text: 'Biometria pendente/em análise'
  },
  {
    key: 'BIOMETRY_REJECTED',
    value: 'BIOMETRY_REJECTED',
    text: 'Biometria recusada'
  },
  {
    key: 'SUPPORT_REQUIRED',
    value: 'SUPPORT_REQUIRED',
    text: 'Análise necessária'
  },
  {
    key: 'REGISTRATION_INCOMPLETE',
    value: 'REGISTRATION_INCOMPLETE',
    text: 'Cadastro incompleto'
  },
  {
    key: 'REGISTRATION_PENDING',
    value: 'REGISTRATION_PENDING',
    text: 'Cadastro pendente'
  }
];

export const commissioningCollaboratorStatusLabelMap: Record<string, string> = {
  ACTIVE: 'Ativo',
  INACTIVE: 'Inativo',
  AWAITING_BIOMETRY: 'Aguardando biometria',
  BIOMETRY_REJECTED: 'Biometria recusada',
  SUPPORT_REQUIRED: 'Análise necessária'
};

export const initialActivationForm: ActivationFormState = {
  recipientType: 'corporation',
  email: '',
  document: '',
  phone: '',
  name: '',
  motherName: '',
  birthdate: '',
  monthlyIncome: '',
  professionalOccupation: '',
  companyName: '',
  tradingName: '',
  annualRevenue: '',
  street: '',
  complementary: '',
  streetNumber: '',
  neighborhood: '',
  city: '',
  state: '',
  zipCode: '',
  referencePoint: '',
  partnerName: '',
  partnerEmail: '',
  partnerDocument: '',
  partnerPhone: '',
  partnerMotherName: '',
  partnerBirthdate: '',
  partnerMonthlyIncome: '',
  partnerProfessionalOccupation: '',
  partnerStreet: '',
  partnerComplementary: '',
  partnerStreetNumber: '',
  partnerNeighborhood: '',
  partnerCity: '',
  partnerState: '',
  partnerZipCode: '',
  partnerReferencePoint: '',
  bankHolderName: '',
  bankHolderType: 'individual',
  bankHolderDocument: '',
  bankCode: '',
  bankBranchNumber: '',
  bankBranchCheckDigit: '',
  bankAccountNumber: '',
  bankAccountCheckDigit: '',
  bankAccountType: 'checking'
};

export const initialCollaboratorActivationForm: CreateCommissioningCollaboratorFormState = {
  ...initialActivationForm,
  recipientType: 'individual',
  estateId: '',
  userId: ''
};

export const initialCreateCommissioningCollaboratorForm = initialCollaboratorActivationForm;

export const initialCreateForm: CreateFormState = {
  estateId: '',
  commissionCollaboratorIds: [],
  amount: 0,
  payerType: 'individual',
  payerName: '',
  payerCpf: '',
  payerEmail: '',
  payerPhone: '',
  payerAddressStreet: '',
  payerAddressNumber: '',
  payerAddressNeighborhood: '',
  payerAddressComplement: '',
  payerAddressZipCode: '',
  payerAddressCity: '',
  payerAddressState: '',
  payerAddressCountry: 'BR',
  description: '',
  paymentMethod: 'PIX'
};
